<section class="mt-section">
  <div v-if="hasResults()">
    <fou-group bottom="medium">
      <v-grid in="10">
        <v-row>
          <v-col>
            <label
              :for="$vId(this, 'family-name')"
              class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size20"
            >
              {{$t('pages.submissions.components.upload.results.font_family')}}
            </label>
            <p
              v-tooltip="{content: $t('pages.submissions.components.upload.results.custom_family_name'), placement: 'right'}"
              :class="$style.quesCustom"
            >
              ?
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col :has="{'default': 5, 'xs': 10, 's': 10}" :class="$style.mB15">
            <fou-group v-if="someResultComplete()">
              <TextField
                name="family name upload"
                label="family name"
                type="text"
                :id="$vId(this, 'family-name')"
                v-model="family.name"
                :placeholder="$t('pages.submissions.components.upload.results.enter_family_name')"
                :input-class="[{'mt-input--error': Object.hasOwn(errors, 'family name upload')},'mt-input--block mt-serif--displayBold mt-serif--size1']"
                :blur="updateFamilyName"
                :moduleName="this.$route.name"
                :foundryId="this.submission.foundry?.foundryId"
                :description="family.name"
                @update-banned-word="bannedWordforFamilyNameLive= $event"
                :focus="familyNameFocus"
                :rules="`min:3|alpha_num_space_ampersand:${hasRole(['foundrySupport'])}|caps_alpha_first:${hasRole(['foundrySupport'])}|required|max:255|script_tag_validate`"
              />
            </fou-group>
            <div v-if="!someResultComplete()" :class="$style.loading">
              <load-animation></load-animation>
            </div>
          </v-col>
          <v-col has="5">
            <fou-group :class="$style.mTN23" v-if="someResultComplete()">
              <externalsku v-if="submissionPackages.length > 0" :id="$vId(this)" familyPackSku />
            </fou-group>
            <div v-if="!someResultComplete()" :class="$style.loading">
              <load-animation></load-animation>
            </div>
          </v-col>
        </v-row>
        <smart-sorting :class="$style.mT15" :getSmartSortTrigger="sortFonts" :result=false v-if="results.items.length > 1"></smart-sorting>
      </v-grid>
    </fou-group>

    <fou-group bottom="medium">
      <v-grid in="10">
        <v-row :class="$style.resultHeader">
          <v-col has="6" off="1">
            <div :class="[$style.name, 'out-left']">
              <span class="mt-label mt-label--black mt-label--none mt-label--size12">
                {{$tc('pages.submissions.components.upload.results.click_style_name', results.items.length, { count:
                results.items.length })}}
              </span>
            </div>
          </v-col>
          <v-col has="2">
            <span :class="$style.ltrSpacing" class="mt-label mt-label--black mt-label--capitalise mt-label--size12">
              {{$t('pages.submissions.components.upload.results.fontfile')}}
            </span>
          </v-col>
          <div class="mt-flex mt-flex--end">
            <span class="mt-label mt-label--black mt-label--capitalise mt-label--size12"
              >{{$t('pages.submissions.components.upload.results.fonttest')}}</span
            >
          </div>
        </v-row>

        <draggable
          :id="$vId(this)"
          element="ul"
          :list="results.items"
          :options="{'onUpdate': updateResultList(), 'disabled': isDragDropDisable}"
          :class="$style.resultList"
          class="mt-group"
          filter=".drag-disabled"
          :preventOnFilter="false"
          @start="draggableStart"
          @end="draggableEnd; unsetSmartSort()"
        >
          <template #item="{element, index}">
            <v-grid
              in="10"
              element="li"
              :class="[$style.resultItem, {[$style.bgColorBlue]: (element?.status === `new` || element?.status === `updated`)}]"
              :key="index"
            >
              <v-row :class="$style.result">
                <v-col has="1" class="mt-flex">
                  <div :class="$style.sorting">
                    <span class="item" :class="$style.dragndrop"></span>
                  </div>
                </v-col>
                <v-col has="6">
                  <div
                    :class="$style.name"
                    class="out-left"
                    v-tooltip="{content: element.fileName, placement: 'bottom'}"
                  >
                    <fou-picture
                      v-if="isResultComplete(element)"
                      :id="$vId(this, 'render-' + element.id)"
                      :src="getBinaryFontRenderSrc(element.id, (getFormattedDefaultStyleName(element)), 30)"
                      :alt="family.name"
                    />
                    <span v-if="!isResultComplete(element)" :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </div>
                  <div class="mt-flex mt-flex--start mt-15">
                    <div class="out-left" :class="[$style.newWidth, $style.posRelative]">
                      <span class="mt-label mt-label--capitalise">
                        {{$t('pages.submissions.components.upload.results.style_name')}}
                      </span>
                      <p
                        v-if="isResultComplete(element)"
                        @mouseleave="mouseleave($event)"
                        v-tooltip="{content: family.name, placement: 'bottom'}"
                        :class="$style.familyPosition"
                      >
                        {{family.name}}
                      </p>
                      <div class="drag-disabled">
                        <StyleTextBox
                        v-if="isResultComplete(element)"
                        :key="`style-${element.id}-${family.name || 'default'}`"
                        :id="$vId(this, 'style-name-' + (element.id))"
                        :name="`style name ${element.id} upload`"
                        :label="`style name ${index+1}`"
                        :default-value="getFormattedDefaultStyleName(element)"
                        :model-value="{id: element.id, name: getFormattedDefaultStyleName(element)}"
                        @blur="(event) => updateSubmissionOnStyleNameBlur(event, element)"
                        :placeholder="$t('pages.submissions.components.upload.results.unknown')"
                        :rules="`caps_alpha_first:${hasRole(['foundrySupport'])}|script_tag_validate|required|lengthChar:80|uniqueStyle: ${getStyleNames()}`"
                        :input-class="['mt-input','mt-serif','mt-serif--size4',
                                      $style.metaField, $style.padLeft,
                                      {'mt-input--error': Object.hasOwn(errors,`style name ${element.id} upload`)}]"
                        :error-class="[$style.errorField]"
                        @mouseover="handleMouseOver"
                        @mouseout="handleMouseOut"
                        >
                      </StyleTextBox>
                        <span v-else :class="$style.loading">
                          <load-animation></load-animation>
                        </span>
                      </div>
                    </div>
                    <externalsku
                      v-if="isResultComplete(element) && submissionPackages.length > 0"
                      :id="$vId(this)"
                      :index="index"
                      single-pack-sku
                      :element-id="element.id"
                      :mouse-over-handler="handleMouseOver"
                      :mouse-out-handler="handleMouseOut"
                    />
                  </div>
                </v-col>
                <v-col has="2">
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]"> {{$t('pages.submissions.components.upload.results.format')}} </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.format}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]">
                      {{$t('pages.submissions.components.upload.results.weight_class')}}
                    </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.fontInfo.weightClass}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]">
                      {{$t('pages.submissions.components.upload.results.width_class')}}
                    </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.fontInfo.widthClass}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]"> {{$t('pages.submissions.components.upload.results.style')}} </span>
                    <span v-if="isResultComplete(element)" :class="[$style.mL5]">{{element.fontInfo.isItalic ? 'italic': 'non-italic'}}</span>
                    <span v-else :class="$style.loading">
                      <load-animation></load-animation>
                    </span>
                  </p>
                  <p class="mb--2" :class="[$style.statusUpperCase, $style.versionRow]" v-if="isResultComplete(element)">
                    <span :class="[$style.bold]">{{ $t('pages.submissions.components.upload.results.version') }}</span>
                    <span v-if="!getBinaryVersionText(element)" :class="[$style.mL5]">
                      {{ $t('pages.submissions.components.upload.results.version_not_found') }}
                    </span>
                    <span
                      v-else-if="getBinaryVersionTooltip(element)"
                      :class="[$style.mL5]"
                      v-tooltip="getBinaryVersionTooltip(element)"
                    >{{ getBinaryVersionDisplay(element) }}</span>
                    <span v-else :class="[$style.mL5]">{{ getBinaryVersionText(element) }}</span>
                  </p>
                  <p
                    class="mb--2"
                    :class="[$style.statusUpperCase, {[$style.mTN15]: hasRole(['foundrySupport']) && submission.status === 'in_review'}]"
                    v-if="submission.isLive && String(element.status).toUpperCase() !== 'ACTIVE'"
                  >
                    <span :class="[$style.bold, $style.statusUpperCase, $style.statusFont]">
                      {{$t('pages.submissions.components.upload.results.status')}}
                    </span>
                    <span
                      :class="[$style.statusUpperCase, $style.statusFont, $style.statusFontColorBlack,$style.mL5, {[$style.statusFontColor]: (element.status === `new` || element.status === `updated`)}]"
                      >
                      {{!element.status ? 'unchanged' : element.status }}
                    </span>
                  </p>
                  <p>
                    <fou-modal ref="delLiveFont" :id="$vId(this, 'del-live-font')" cols="8">
                      <template #trigger >
                        <button class="mt-link" v-if="element.status === 'new'">
                          <trash-icon></trash-icon>
                        </button>
                      </template>
                      <template #content>
                        <div :class="$style.slotContent">
                          <h3 class="mt-h3" :class="[$style.modalTitle, $style.modalTextColor]">
                            <warning-triangle-icon></warning-triangle-icon>
                            {{$t('pages.submissions.components.upload.results.live_del.title')}}
                          </h3>
                          <fou-group bottom="medium">
                            <div :class="[$style.left, $style.modalTextColor]">
                              <p
                                class="mt-serif--bold"
                                v-html="$t('pages.submissions.components.upload.results.live_del.text1')"
                                :class="$style.noteText"
                              />
                              <p :class="$style.noteText">
                                <span v-html="$t('pages.submissions.components.upload.results.live_del.text2a')">
                                </span>
                                <span
                                  class="mt-serif--bold"
                                  v-html="$t('pages.submissions.components.upload.results.live_del.text2b')"
                                >
                                </span>
                                <span v-html="$t('pages.submissions.components.upload.results.live_del.text2c')">
                                </span>
                                <button @click="openFoundryLink" target="_blank" class="mt-link">here</button>.
                              </p>
                              <p :class="$style.noteText3">
                                {{$t('pages.submissions.components.upload.results.live_del.text3')}}
                                <input
                                  v-model="deleteText"
                                  @keyup="renderDeleteButton($event, index)"
                                  class="mt-input mt-serif"
                                  :class="$style.customDelModalInput"
                                />
                              </p>
                            </div>
                          </fou-group>
                          <fou-group class="mt-flex mt-flex--between" :class="$style.modalControls">
                            <button
                              type="button"
                              class="mt-button mt-button--inverted"
                              :class="$style.modalControlsItem"
                              @click="hide(); unsetDeleteTxt()"
                            >
                              {{$t('pages.submissions.components.upload.results.live_del.go_back')}}
                            </button>
                            <button
                              :disabled="isDisabledDeleteButton"
                              class="mt-button"
                              :class="$style.modalControlsItem"
                              @click="removeResult(index); hide(); unsetDeleteTxt()"
                            >
                              {{$t('pages.submissions.components.upload.results.live_del.del_style')}}
                            </button>
                          </fou-group>
                        </div>
                      </template>
                    </fou-modal>
                  </p>
                </v-col>
                <v-col has="1">
                  <div v-if="isResultComplete(element)">
                    <binary-validation-icons
                      :index="element.id"
                      :result="element"
                      :is-complete="showBinaryValidationProgress(element)"
                    >
                    </binary-validation-icons>
                  </div>
                  <span v-else :class="[$style.loading, $style.resultStatusIcon]">
                    <load-animation></load-animation>
                  </span>
                </v-col>
              </v-row>
              <v-row> </v-row>
            </v-grid>
          </template>
        </draggable>
        <div>
          <p class="mt-error" v-for="error in styleNameErrors">{{error}}</p>
        </div>
      </v-grid>
    </fou-group>

    <fou-group bottom="medium" v-if="submission.status === 'live'">
      <fou-group>
        <p class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size20">
          {{$t('pages.submissions.components.upload.results.validator.title')}}
        </p>
      </fou-group>
      <fou-group>
        <validator :id="$vId(this, 'results')" optimist @error-on-font="validateErrorOnFont" />
      </fou-group>
      <fou-group>
        <fou-modal :id="$vId(this, 'show-font-validation-results')" cols="10">
          <template #trigger>
            <button type="button" class="mt-link">
              {{$t('pages.submissions.components.upload.results.validator.show_overlay')}}
            </button>
          </template>
          <template #content>
            <div>
              <fou-container :id="$vId(this, 'myfonts-display')" cols="10" boundless>
                <template #header>
                  <p class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size30">
                    {{$t('pages.submissions.components.upload.results.validator.overlay.title')}}
                  </p>
                </template>
                <template #content>
                  <div>
                    <v-grid in="10" :class="$style.overlayInner">
                      <v-row>
                        <v-col has="8" off="1">
                          <fou-group class="out-left out-right">
                            <p
                              v-html="$sanitize($t('pages.submissions.components.upload.results.validator.overlay.description'))"
                            ></p>
                          </fou-group>
                          <fou-group bottom="medium" class="out-left out-right">
                            <validator :id="$vId(this, 'overlay')" />
                          </fou-group>
                          <fou-group></fou-group>
                        </v-col>
                      </v-row>
                    </v-grid>
                  </div>
                </template>
              </fou-container>
            </div>
          </template>
        </fou-modal>
      </fou-group>
    </fou-group>
    <customerMessage
      :id="$vId(this)"
      :as="$t('pages.submissions.components.customerMessage.textarea.name')"
      rules="script_tag_validate"
      :fontResults="results"
      :errors="errors"
    />
  </div>

  <!-- //Popup start for custom package alert -->
  <fou-modal :id="$vId(this, 'customPackagePopupModal')" v-if="getCustomPackageModal" :visible="getCustomPackageModal" cols="6" :class="$style.popUpContainer">
    <template #content>
      <div>
        <p :class="$style.warnM">
          {{ $t('pages.submissions.components.upload.results.customPackageModal.title', {countDeletePackage: getValidCustomPackageLength}) }}</p>
        <p :class="$style.customPackageWarnDesc">{{
            $t('pages.submissions.components.upload.results.customPackageModal.desc', {
              countDeletePackage: getValidCustomPackageLength,
              allowedCustomPackageLength: getAllowedCustomPackageLength,
              countFontFiles: getCountFontFiles
            })
          }}</p>
        <div class="row">
          <button type="button" id="save" ref="save_btn" :class="$style.gotItBtn" @click="closeCustomPackagePopupModal">Got
            it!
          </button>
        </div>
      </div>
    </template>
  </fou-modal>
  <!-- Popup end -->
</section>
